import { __decorate } from "tslib";
import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import { getLibPortaitListApi } from '@blade-sxp/record-center/api/index';
let PortaitLibray = class PortaitLibray extends Vue {
    value;
    options = [];
    curValue = '';
    onValue(nv) {
        this.curValue = this.value;
    }
    handleChange() {
        this.$emit('update:value', this.curValue);
        this.$emit('change', this.curValue);
        console.log('handleChange portait', this.curValue);
    }
    init() {
        this.getOption();
    }
    async getOption() {
        try {
            const res = await getLibPortaitListApi();
            console.log('getLibPortaitListApi res', res);
            this.options = res?.list ?? [];
        }
        catch (e) {
            console.log(e);
        }
    }
    created() {
        this.init();
    }
};
__decorate([
    Prop()
], PortaitLibray.prototype, "value", void 0);
__decorate([
    Watch('value', { deep: true, immediate: true })
], PortaitLibray.prototype, "onValue", null);
PortaitLibray = __decorate([
    Component({
        name: 'portait-libray',
        i18n: {
            messages: {
                zh: {
                    placeholder: 'Portait Library',
                },
                en: {
                    placeholder: 'Portait Library',
                },
            },
        },
    })
], PortaitLibray);
export default PortaitLibray;
